<template>

    <!-- Page Sidebar Ends-->
    <div class="page-body">
        <PageTitle title="Survey list"  />
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-header">
                            <button class="btn btn-secondary" type="button" data-bs-toggle="modal"
                                data-original-title="test" data-bs-target="#surveyAdd">Add Survey</button>
                        </div>
                        <div class="card-body badge-spacing">
                            <div class="table-responsive custom-scrollbar">
                                <table class="table display" id="basic-1">
                                    <thead>
                                        <tr>
                                            <th>Sr.No.</th> 
                                            <th>Nagarpalika</th> 
                                            <th>Name</th> 
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr  v-for="(item ,index)  in survey" :key="item.id" >
                                            <th>{{index+1}}</th> 
                                            <td>{{item.np_name}}</td>
                                            <td>{{item.name}}</td>
                                            <td>{{(item.status==1)?'Active':'De-Active'}}</td>
                                            <td>
                                                <ul class="action">
                                                    <li class="edit" @click="edit_survey(item.id)"><i class="icon-pencil-alt"></i></li>
                                                    <li class="delete" @click="remove_survey(item.id)"><i class="icon-trash"></i></li>
                                                </ul>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- footer   start-->

    <ModalsPart v-if="!['login'].includes($route.name)"   :userDetails="userDetails" :nagarpalika_list="nagarpalika_list"  @getSurveyData="updateSurveyData"/>
</template>

<script>
// @ is an alias to /src 
import PageTitle from '@/components/PageTitle.vue';
import ModalsPart from '@/components/Modals.vue';
import axios from 'axios';
const config = {
            headers: {
               "Content-Type": "application/x-www-form-urlencoded"
            },
            responseType: 'json'
         };
export default {
    name: 'Survey', 
    components: {
        PageTitle, ModalsPart
    }, mounted() {
        this.getBasics();

    }, data() {
        return {
          survey: [],
          nagarpalika_list:[],
          userDetails:[]
        }
    },
    methods: { 
        updateSurveyData(value) {
            this.survey = value;
        },
        getBasics() {
            var self = this;
            axios.post('getSurvey').then(function (response) {
                self.survey = response.data.survey; 
                self.nagarpalika_list = response.data.nagarpalikas; 
                self.userDetails = response.data.userDetails; 
                window.scrollTo(0, 0);
            });
        },
        remove_survey(id) {
            var self = this;
            axios.post('removeSurvey', {id:id}).then(function (response) {
                 self.$swal(response.data.msg);
                
                if(response.data.is==1){
                    self.survey = response.data.survey; 
                self.nagarpalika_list = response.data.nagarpalikas; 
                }
                window.scrollTo(0, 0);
            });
        }
       
    }
}
</script>
